import React, {useEffect, useState} from "react";
import ApiService from "../../../../../services/ApiService";
import ProgressBar from "@ramonak/react-progress-bar";
import {notification, Typography} from "antd";
import {uuidv4} from "../../../../../utils";
import {getDeviseSymbol} from "../../../../../i18n";

const {Text,Title}=Typography

export default function ScreenDonSection({context,campagneData,})
{

    const formater=new Intl.NumberFormat('fr-FR', { maximumFractionDigits:2 })

    const partnerMontant=campagneData?.partnerMontant || 1

    let donorName=campagneData.config?.donorName || "Parrainages"

    const screenOptions=campagneData?.screenOptions || {}


    const minMontant=screenOptions?.minMontant || 0
    const teams=(Array.isArray(campagneData?.teams)?campagneData.teams:[]).filter(i=>i.objectif>=minMontant).reverse()

    return (
        <div style={{overflow:"visible",width:"100%",height:"15vh",display:"flex",alignItems:"center",flexDirection:"row-reverse",gap:20,padding:"0 1.5vw"}}>
            {teams.map((t,index)=>{

                //console.log(index)

                let className="screen-don-card"

                if(index<4){
                    className+=" screenDonFadeIn"
                }else{
                    className+=" screenDonFadeOut"
                }

                //console.log(className)

                return(
                    <div style={{flexDirection:"column"}} key={t.id} className={className}>
                            <span style={{color:"#FFF",fontSize:"2.2vh",textAlign:"center",textOverflow:"ellipsis",whiteSpace:"nowrap",width:"90%",overflow:"hidden"}}>{t.label}</span>
                            <span style={{color:"#FFF",fontSize:"3vh",textAlign:"center"}}>{formater.format(t.objectif)}{getDeviseSymbol(context)}</span>
                    </div>
                )
            })}
        </div>
    )
}
